<template>
  <div>
    <div v-if="showLoading" class="pa-2 text-xs-center" style="width: 100%">
      <v-progress-circular
          :size="40"
          :width="5"
          color="primary"
          indeterminate
      ></v-progress-circular>
    </div>
    <div
        v-for="message in messagesAdditional"
        v-else
        :key="message.id"
    >
      <v-card
          @contextmenu="e => showContextMenu(e, message)"
          flat
          @dragstart="$emit('dragMessage', message); $emit('showLinkOffice', false)"
          :draggable="typeof userPrincipal.default != 'undefined' && userPrincipal.default == true"
      >
        <v-layout
            row
            align-center
            style="overflow-x: hidden; cursor: pointer"
            :class="selectedMessageMessageIds.has(message.id) ? 'selectedMessage' : (!message.isRead ? 'unread' : 'read')"
            @click="messageClicked(message)"
            class="py-1"
        >
          <v-flex shrink class="px-1">
            <!--Mail Flag-->
            <div v-if="typeof userPrincipal.default != 'undefined' && userPrincipal.default == true">
              <v-tooltip top>
                <v-icon @click="flagMessageFn(message)" style="cursor: pointer" slot="activator"
                        :class="message.starred ? 'red--text' : (typeof selectedMessage != 'undefined' && selectedMessage != null && selectedMessage.id == message.id ? 'white--text' : 'greyType--text text--lighten-2')">
                  flag
                </v-icon>
                <span>{{ message.starred ? 'Remove Flag' : 'Flag Message' }}</span>
              </v-tooltip>
            </div>
            <!--Linked To Task-->
            <div v-if="typeof message.tasks != 'undefined' && message.tasks.length > 0">
              <v-icon class="px-1" color="primary">assignment_turned_in</v-icon>
            </div>
          </v-flex>
          <v-flex xs12 style="overflow-x: hidden">
            <v-layout column>
              <v-flex shrink style="overflow-x: hidden">
                <v-layout row align-center>
                  <v-flex
                      xs12
                      class="subheading px-1 text-truncate"
                      style="white-space: pre; overflow-x: hidden"
                      v-if="isSentView ? (message.to != null && message.to != '') : (message.from != null && message.from != '')"
                      :style="!message.isRead ? 'font-weight: 500' : null"
                  >
                    <template v-if="isSentView">To: {{ message.to.split('<')[0] }}</template>
                    <template v-else>{{ message.from.split('<')[0] }}</template>
                  </v-flex>
                  <v-flex shrink class="pr-1">
                                    <span style="white-space: nowrap" class="greyType--text caption">
                                        {{ message.displayDate }}
                                    </span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex shrink style="overflow-x: hidden">
                <v-layout row style="overflow-x: hidden" align-center>
                  <v-flex xs12 style="overflow-x: hidden">
                    <div style="overflow-x: hidden" class="text-truncate"
                         v-if="message.subject != null && message.subject != ''">
                      <span class="body-1" style="white-space: pre;">{{ message.subject }}</span>
                    </div>
                    <div style="overflow-x: hidden" class="text-truncate">
                      <span class="caption greyType--text"
                            style="white-space: pre;">{{ message.snippetDisplay.replace(/(\r\n|\n|\r)/gm, " ") }}</span>
                    </div>
                  </v-flex>
                  <v-flex shrink>
                    <v-tooltip top>
                      <v-icon
                          color="red"
                          slot="activator"
                          style="cursor: pointer"
                          class="pa-1"
                          @click="archiveMessageFn(message)"
                          :disabled="typeof userPrincipal.default == 'undefined'"
                      >
                        archive
                      </v-icon>
                      <span>Archive Message</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-progress-linear
            v-if="message.showLoading"
            indeterminate
            height="3"
            class="pa-0 ma-0"
        ></v-progress-linear>
        <v-divider></v-divider>
      </v-card>
    
    </div>
    
    <div
        v-if="!showLoading && typeof nextLink != 'undefined' && nextLink != null && nextLink != ''"
        class="text-xs-center"
    >
      <v-btn
          flat
          color="secondary"
          :loading="loadingNext"
          :disabled="loadingNext"
          @click="loadMoreFn"
      >
        Load More
      </v-btn>
    </div>
    
    <v-menu
        v-if="contextMessage"
        v-model="showMenu"
        :position-x="x"
        :position-y="y"
        absolute
        offset-y
    >
      
      <div style="width: 350px; background: var(--card-back); cursor: pointer">
        <v-card >
          <v-list class="py-0 my-0">
            <v-list-tile
                v-if="selectedMessages.length"
                ripple
                @click="contextSelectMultiple"
            >
              <div class="c-d-flex c-align-center">
                <div class="mr-3">
                  <v-icon>{{ selectMultiple ? 'check_box' : 'check_box_outline_blank' }}</v-icon>
                </div>
                <div class="text-truncate">
                  Select Multiple
                </div>
              </div>
            </v-list-tile>
            
<!--            <v-list-tile-->
<!--                ripple-->
<!--                @click="eventBus.$emit('linkZohoMail', true)"-->
<!--            >-->
<!--              <div class="c-d-flex c-align-center">-->
<!--                <div class="mr-3">-->
<!--                  <v-icon small>link</v-icon>-->
<!--                </div>-->
<!--                <div class="text-truncate">-->
<!--                  Link to task-->
<!--                </div>-->
<!--              </div>-->
<!--            </v-list-tile>-->
<!--            <v-list-tile-->
<!--                ripple-->
<!--                @click="() => createTaskClick()"-->
<!--            >-->
<!--              <div class="c-d-flex c-align-center">-->
<!--                <div class="mr-3">-->
<!--                  <v-icon small>add</v-icon>-->
<!--                </div>-->
<!--                <div class="text-truncate">-->
<!--                  Create task-->
<!--                </div>-->
<!--              </div>-->
<!--            </v-list-tile>-->
          </v-list>
<!--          <div v-for="taskId in contextMessage.taskIds">-->
<!--            <task-loading-container-->
<!--                v-if="loadingTasks.includes(taskId)"-->
<!--                :task-id="taskId"-->
<!--            />-->
<!--            <task-container-->
<!--                v-else-if="tasks[taskId]"-->
<!--                :userInfo="userInfo"-->
<!--                :task="tasks[taskId]"-->
<!--                :taskBar="false"-->
<!--                :showNav="false"-->
<!--                @taskSelected="() => eventBus.$emit('gotoTask', tasks[taskId])"-->
<!--            />-->
<!--          -->
<!--          </div>-->
        </v-card>
      </div>
    </v-menu>
    
  </div>
</template>

<script>
import {codeBaseMixin} from "../../../../codeBaseMixin";
import {eventBus} from "@/main";
import TaskLoadingContainer from "@/components/TaskContainer/TaskLoadingContainer.vue";
import TaskContainer from "@/components/TaskContainer/TaskContainer.vue";

export default {
  components: {TaskContainer, TaskLoadingContainer},
  mixins: [codeBaseMixin],
  props: {
    userInfo: Object,
    messages: Array,
    nextLink: String,
    showLoading: {
      type: Boolean,
      default: false
    },
    selectedMessage: Object,
    loadingNext: Boolean,
    loadMoreFn: Function,
    dragMessage: Object,
    movingMessage: Boolean,
    archiveMessageFn: Function,
    flagMessageFn: Function,
    showLinkOffice: Boolean,
    userPrincipal: Object,
    selectedMessages: Array,
    selectedLabel: Object,
  },
  data() {
    return {
      selectMultiple: false,
      contextMessage: null,
      showMenu: false,
      x: 0,
      y: 0,
    }
  },
  watch: {
    messages: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        if (!newVal?.length)
          return this.$emit('update:selectedMessages', [])
        this.$emit('update:selectedMessages', this.selectedMessages.filter(v => newVal.includes(v)));
      }
    },
    selectMultiple(val) {
      if (!val) {
        this.$emit('update:selectedMessages', [])
      }
    },
    selectedMessages: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        if (!newVal?.length) {
          this.selectMultiple = false
          eventBus.$emit('linkZohoMail', false)
        }
        
        let newArr = newVal || []
        let oldArr = oldVal || []
        
        if (newArr.length && JSON.stringify(newArr) === JSON.stringify(oldArr)) return
        
        let added = newArr.find(v => !oldArr.includes(v))
        if (added) return this.$emit('selectMessage', added)
        this.$emit('selectMessage', null)
      }
    }
  },
  methods: {
    contextSelectMultiple() {
      this.selectMultiple = !this.selectMultiple
      if (this.selectMultiple) {
        if (!this.selectedMessageMessageIds.has(this.contextMessage.id))
          this.$emit('update:selectedMessages', this.selectedMessages.concat(this.contextMessage))
      } else {
        this.$emit('update:selectedMessages', [this.contextMessage])
      }
    },
    
    messageClicked(message) {
      // this.markMessageAsRead(message)
      if (this.selectMultiple)
        if (this.selectedMessageMessageIds.has(message.id))
          this.$emit('update:selectedMessages', this.selectedMessages.filter(v => v !== message))
        else
          this.$emit('update:selectedMessages', this.selectedMessages.concat(message));
      else
        this.$emit('update:selectedMessages', this.selectedMessageMessageIds.has(message.id) ? [] : [message]);
    },
    
    showContextMenu(e, message) {
      
      if (!this.selectedMessages.length) {
        this.$emit('update:selectedMessages', [message])
      } else if (!this.selectMultiple) {
        this.$emit('update:selectedMessages', [message])
      } else if (this.selectMultiple && !this.selectedMessageMessageIds.has(message.id)) {
        this.$emit('update:selectedMessages', this.selectedMessages.concat(message))
      } else if (this.selectMultiple && !this.selectedMessageMessageIds.has(message.id)) {
        this.$emit('update:selectedMessages', this.selectedMessages.concat(message))
      }
      
      this.contextMessage = message
      e.preventDefault()
      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
      // this.refreshTasks(message.taskIds)
    },
  },
  computed: {
    messagesAdditional() {
      return this.messages.map((message) => {
        message.displayDate = this.getShortDate(message.date);
        message.snippetDisplay = message.snippet != null ? message.snippet.replace(/\n/g, " ") : '';
        if (this.movingMessage && this.dragMessage != null && this.dragMessage.id == message.id) {
          message.showLoading = true;
        } else {
          message.showLoading = false;
        }
        return message
      })
    },
    selectedMessageMessageIds() {
      return new Set(this.selectedMessages.map(v => v.id))
    },
    isSentView() {
      return this.selectedLabel && this.selectedLabel.displayName === 'Sent Items'
    },
  },
}
</script>

<style scoped>
.selectedMessage {
  border-left: 4px solid var(--v-secondary-base);
  background-color: var(--selected-item);
}

.read {
  border-left: 4px solid rgba(0, 0, 0, 0);
  background: var(--hover-item-background);
}

.unread {
  border-left: 4px solid var(--v-primary-base);
}

.read:hover {
  border-left: 4px solid rgba(0, 0, 0, 0);
  background-color: var(--hover-item-background);
}

.unread:hover {
  border-left: 4px solid rgba(0, 0, 0, 0);
  background-color: var(--hover-item-background);
}
</style>
